var $button = $('.js-back-to-top')

if(!$button) return;

window.onscroll = function () {showButton()}

function showButton() {
  if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
    $button.css('display','block')
  } else {
    $button.css('display','none')
  }
}

$button.click(function() {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
})